<template>
  <div id="aliParkPID">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>支付宝车主服务</el-breadcrumb-item>
          <el-breadcrumb-item>支付宝场库ID管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="demo-form-inline">
        <el-row>
          <el-col :span="22">
            <el-form-item label="客户名称::"
                          style="margin-bottom: 10px;">
              <el-select v-model="selCustID"
                         filterable
                         clearable
                         placeholder="所有客户">
                <el-option v-for="item in choiceCusts"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库名称::">
              <el-input placeholder="请输入场库名称"
                        v-model="queryParkName"
                        class="input-with-select">
              </el-input>
            </el-form-item>
            <el-form-item label="场库编号::">
              <el-input placeholder="请输入场库编号"
                        v-model="queryParkNo"
                        class="input-with-select">
              </el-input>
            </el-form-item>
            <el-form-item label="支付宝场库ID::">
              <el-select v-model="aliParkID"
                         filterable
                         clearable
                         placeholder="支付宝场库ID？"
                         style="width:120px">
                <el-option v-for="item in PidItems"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="bindQuery">查询</el-button>
              <el-button type="success"
                         size="small"
                         icon="el-icon-share"
                         :loading="export_loading"
                         v-if="is_export"
                         @click="exportData">{{export_msg}}</el-button>
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-table :data="parkList"
                border
                highlight-current-row
                style="width: 100%"
                v-loading="loading"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                         width="50"
                         label="序号"
                         align="right"
                         :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         width="80"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName"
                         width="160"
                         label="客户名称">
        </el-table-column>
        <el-table-column prop="fParkNo"
                         width="100"
                         label="场库编号">
        </el-table-column>
        <el-table-column prop="fParkName"
                         width="160"
                         label="场库名称">
        </el-table-column>
        <el-table-column prop="fParkTypeName"
                         width="100"
                         label="场库类型">
        </el-table-column>
        <el-table-column prop="fParkCount"
                         width="80"
                         align="right"
                         label="车位数量">
        </el-table-column>
        <el-table-column prop="fResCount"
                         width="80"
                         align="right"
                         label="保留数量">
        </el-table-column>
        <el-table-column prop="PID"
                         label="商户PID"> </el-table-column>
        <el-table-column prop="AliParkID"
                         label="支付宝场库ID"> </el-table-column>
        <el-table-column prop="fAddress"
                         label="场库地址"> </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageIndex"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
export default {
  name: 'aliParkPID',
  data () {
    return {
      export_msg: '导出',
      export_loading: false,
      is_export: false,
      PidItems: [{ value: 0, label: '无' }, { value: '1', label: '有' }],
      loading: false,
      tab_height: 0,
      is_edit: true,
      aliParkID: '',
      queryParkName: '',
      queryParkNo: '',
      selCustID: '',
      choiceCusts: [],
      parkList: [],
      tableHeight: 0,
      pageSize: 20,
      pageIndex: 1,
      total: 0
    }
  },
  methods: {
    bindQuery () {
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageIndex - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageIndex = index
      this.initData()
    },
    exportData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      api.getParkPIDList({ isExport: 1, aliParkID: this.aliParkID, fCustID: this.selCustID, fParkName: this.queryParkName.trim(), fParkNo: this.queryParkNo.trim() }).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_支付渠道场库.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    initData () {
      this.parkList = []
      this.loading = true
      api.getParkPIDList({ isExport: 0, aliParkID: this.aliParkID, pageSize: this.pageSize, pageIndex: this.pageIndex, fCustID: this.selCustID, fParkName: this.queryParkName.trim(), fParkNo: this.queryParkNo.trim() }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parkList = data.Data.data || []
              this.total = data.Data.count
            }
          }
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 190
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 90100 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.initData()
    park.getCustByGroup({}).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            let all = {}
            all['fCustID'] = ' '
            all['unionName'] = '所有客户'
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            // if (this.choiceCusts && this.choiceCusts.length > 0) {
            //    this.selCustID = this.choiceCusts[0].fCustID
            // }
            // this.choiceCusts.unshift(all)
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style></style>
<style scoped>
fieldset {
  padding-bottom: 0px;
}
.search_list .t {
  color: #1eb1fb;
  font-weight: 700;
  min-height: 35px;
  line-height: 35px;
  font-size: 14px;
  padding: 0 7px;
}
.search_list .a {
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666;
  padding: 0 7px;
}
.search_list {
  height: 300px;
  width: 300px;
  overflow-y: auto;
  float: left;
}
.search_list .el-row {
  margin-top: 0px;
}
.search_list .el-row.selected,
.search_list .el-row:hover {
  background: #dcd9d9;
  cursor: pointer;
}
.parkMain_BaseInfo .el-select {
  width: 100%;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.trans_row {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}
.tab_foot {
  width: 110px;
  height: 80px;
  background: #ccc;
}
.dialog-footer {
  text-align: right;
  padding: 20px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/aliParking/aliParkPID.vue